import { useEffect, useState } from 'react';
import type { PublicChangelogRelease } from './public-changelog-config';
import type { PublicChangelogConfig } from './public-changelog-config';

type UsePublicChangelogResult = {
    hasNewReleases: boolean;
    markAsSeen: () => void;
    releases: PublicChangelogRelease[];
};

export const usePublicChangelog = (
    config: PublicChangelogConfig
): UsePublicChangelogResult => {
    const [hasNewReleases, setHasNewReleases] = useState(false);
    const [latestVersion, setLatestVersion] = useState<string | undefined>(
        undefined
    );

    useEffect(() => {
        // Get the latest version from the changelog
        const latest = config.releases[0]?.version;

        if (!latest) {
            setHasNewReleases(false);
            return;
        }

        setLatestVersion(latest);

        // Get the last seen version from localStorage
        const lastSeenVersion = localStorage.getItem(config.localStorageKey);

        // Determine if there are new releases
        if (lastSeenVersion !== latest) {
            setHasNewReleases(true);
        } else {
            setHasNewReleases(false);
        }
    }, []);

    const markAsSeen = () => {
        if (latestVersion) {
            localStorage.setItem(config.localStorageKey, latestVersion);
            setHasNewReleases(false);
        }
    };

    return {
        hasNewReleases,
        markAsSeen,
        releases: config.releases,
    };
};
